import React from "react";
import { List, Tag, Button, Space, Empty, Spin, Tooltip } from "antd";
import { RiMapPin5Fill, RiArrowLeftRightLine } from "react-icons/ri";
import dayjs from "dayjs";

const SEVERITY_CONFIG = {
  critical: { color: "red", text: "緊急" },
  warning: { color: "orange", text: "警告" },
  info: { color: "blue", text: "資訊" },
};

// Same `line_cross:<id>` recognition as LiveDashboardModal's AlertHistoryPanel.
const isTripwireAlert = (alert) =>
  typeof alert?.type === "string" && alert.type.startsWith("line_cross:");

// Row click seeks + focuses the subject; this tab never auto-scrolls while
// replay is playing (no effect here keys off the playhead at all).
const AlertHistoryTab = ({
  alerts,
  loading,
  hasMore,
  loadingMore,
  onLoadMore,
  onAlertClick,
}) => {
  if (!loading && alerts.length === 0) {
    return (
      <Empty
        description="此範圍內無警報"
        image={Empty.PRESENTED_IMAGE_SIMPLE}
      />
    );
  }

  return (
    <Spin spinning={loading}>
      <List
        dataSource={alerts}
        renderItem={(alert) => {
          const severity =
            SEVERITY_CONFIG[alert.severity] || SEVERITY_CONFIG.info;
          return (
            <List.Item
              key={alert.id}
              style={{
                cursor: "pointer",
                padding: "8px 12px",
                borderLeft: `4px solid ${severity.color === "red" ? "#ff4d4f" : severity.color === "orange" ? "#faad14" : "#1890ff"}`,
                marginBottom: 6,
                borderRadius: 4,
                backgroundColor: "#fafafa",
              }}
              onClick={() => onAlertClick(alert)}
            >
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Space wrap size={6}>
                  <Tag color={severity.color}>{severity.text}</Tag>
                  <span style={{ fontSize: 12, color: "#8c8c8c" }}>
                    {dayjs(alert.timestamp).format("YYYY-MM-DD HH:mm:ss")}
                  </span>
                  {alert.personnelName && <Tag>{alert.personnelName}</Tag>}
                  {isTripwireAlert(alert) && (
                    <Tag color="magenta" icon={<RiArrowLeftRightLine />}>
                      越線
                    </Tag>
                  )}
                  <span>{alert.message}</span>
                  {isTripwireAlert(alert) && alert.metadata?.uncertain && (
                    <Tooltip title="移動速度或資料間隔超出合理範圍，此次越線判定為不確定">
                      <Tag color="gold">不確定</Tag>
                    </Tooltip>
                  )}
                  {isTripwireAlert(alert) && alert.metadata?.degraded && (
                    <Tooltip title="部分機具定位器離線，判定基於現有可用定位器">
                      <Tag color="default">部分定位器離線</Tag>
                    </Tooltip>
                  )}
                  {alert.acknowledged && <Tag color="green">已確認</Tag>}
                  {alert.dismissed && <Tag color="default">已關閉</Tag>}
                </Space>
                <Button
                  type="text"
                  size="small"
                  icon={<RiMapPin5Fill />}
                  onClick={(e) => {
                    e.stopPropagation();
                    onAlertClick(alert);
                  }}
                />
              </div>
            </List.Item>
          );
        }}
      />
      {hasMore && (
        <div style={{ textAlign: "center", padding: 12 }}>
          <Button loading={loadingMore} onClick={onLoadMore}>
            載入更多
          </Button>
        </div>
      )}
    </Spin>
  );
};

export default AlertHistoryTab;
